import React from "react";

const ChatButton = () => {
  return (
    <div className="chat-btn">
      Chat with Us
    </div>
  );
};

export default ChatButton;
